import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ErrorBoundary } from '../../../error-boundary'
import { useLocale } from '../../../hooks/useLocale'
import EndOfJourneyPeerManagement from './EndOfJourneyPeerManagement'
import EndOfJourneyReport from './EndOfJourneyReport'

export const EndOfJourney = () => {
  const { t } = useLocale()
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const tab = params.get('tab')
  const [selectedIndex, setSelectedIndex] = useState(tab === 'results' ? 1 : 0)

  const handleTabChange = (index: number) => {
    setSelectedIndex(index)
    if (index === 1) {
      navigate('./?tab=results')
    } else {
      navigate('./?tab=respondent-management')
    }
  }

  return (
    <div className="space-y-4">
      <TabGroup selectedIndex={selectedIndex} onChange={handleTabChange}>
        <TabList className="flex space-x-4 border-b border-gray-200">
          <Tab
            className={({ selected }) =>
              `border-b-2 px-4 py-2 text-sm font-medium transition-all
              ${
                selected
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              }`
            }
          >
            {t('peer_response_management')}
          </Tab>
          <Tab
            className={({ selected }) =>
              `border-b-2 px-4 py-2 text-sm font-medium transition-all
              ${
                selected
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              }`
            }
          >
            {t('report_results')}
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <EndOfJourneyPeerManagement />
          </TabPanel>
          <TabPanel>
            <ErrorBoundary>
              <EndOfJourneyReport />
            </ErrorBoundary>
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </div>
  )
}
